import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {Button} from "../account/misc/Button";
import PosApi from "../../api/PosApi";
import {useRecoilState, useRecoilValue} from "recoil";
import {memberState, posState} from "../../state/atoms";
import {Spinner} from "../account/misc/Spinner";
import CheckCircle from "../icons/CheckCircle";
import './Popmenu.scss';
import {handleServerError} from "../../util/ErrorHandler";
import DashboardApi from "../../api/DashboardApi";
import {connectToPopmenu} from "../../service/PosService";
import {error} from "../../service/MessageService";

export default function Popmenu() {
  const [searchParams] = useSearchParams();
  const member = useRecoilValue(memberState);
  const [linked, setLinked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [, setPos] = useRecoilState(posState);
  const navigate = useNavigate();

  useEffect(() => {
    if (!member || !member.id) return;

    const code = searchParams.get("code");
    const err = searchParams.get("error");

    if (!code && !err) return;

    if (err === 'access_denied') {
      error('Access was not permitted');
    } else if (code) {
      setLoading(true);

      PosApi.authPopmenu({code, memberId: (member.ownerId || member.internalId)}).then(() => {
        const url = window.location.href.split('?')[0];
        window.history.pushState({path: url}, "", url);

        DashboardApi.status().then((resp) => {
          setLinked(true);
          setLoading(false);
          const {pos, toastEmail, square, treez, popmenu} = resp.data;

          setPos({
            enabled: !!pos,
            toastEmail: toastEmail ?? "",
            isToast: !!toastEmail,
            isSquare: !!square,
            isTreez: !!treez,
            isPopmenu: !!popmenu
          });

          if ('true' === window.localStorage.getItem('popmenuFlowReg')) {
            window.localStorage.removeItem('popmenuFlowReg');
            navigate("/account/register", {state: {resumePopmenuFlow: true}});
          }
        });
      }).catch(e => {
        setLoading(false);
        handleServerError(e);
      });
    } else {
      error('No code');
    }
  }, [searchParams, member, setPos, navigate]);

  return <>
    {loading && <span>Importing your menu data...</span>}
    {loading && <div className={'spinner'}>
      <Spinner/>
    </div>}
    {!linked && !loading && <Button onClick={() => connectToPopmenu(false, member.email)}>Login into Popmenu</Button>}
    {linked && <div className={'popmenu-linked'}>
      <CheckCircle/>
      <h2>You're all set!</h2>
      <p>You can access your Popmenu data in any design.</p>
    </div>}
  </>
}
